export enum TooltipMessage {
  Phone = 'You must provide a mobile number so that you may receive SMS codes in order to verify your identity and access your account.',
  Street = 'P. O. boxes and non-US addresses are not permitted. APO and FPO addresses are accepted.',
  StreetStarlingReinstatement = 'Non-US addresses are not permitted. APO and FPO addresses are accepted.',
  TotalMonthlyIncome = 'Alimony, child support, or separate maintenance income need not be disclosed if you do not wish to have it considered as a basis for repaying this obligation.',
}

export enum StaticErrorMessage {
  InvalidSSN = 'Invalid SSN.',
  Required = 'is required.',
  InvalidDate = 'The date is invalid.',
  InvalidPhoneFormat = 'Invalid phone number format.',
  InvalidUSNumber = 'Must be US phone number.',
  PhoneAlreadyInUse = 'This mobile phone number is already in use.',
  InvalidEmail = 'Invalid email address.',
  UnCheckedCheckBox = 'You must read and agree with our compliance policies before moving forward.',
  PoBox = 'P.O. boxes and non-US addresses are not permitted.',
  FirstLastName = "Only Latin letters, space, and special characters (-, ') are allowed.",
  StreetAddressAndUnit = "Only Latin letters, space, numbers, and special characters (-, /, ., #, ',`) are allowed.",
  OnlyLatinLetters = 'Only Latin letters are allowed.',
  City = "Only Latin letters, space, and special characters (', -) are allowed.",
  InvalidLineType = "We don't support this phone type. Please enter a valid mobile number.",
  SSNNotMatchOfferData = 'SSN does not match our records.',
  TwilioPhoneNumberIsInvalid = 'Phone number is invalid',
}
